import { Avatar, Badge, Checkbox, Chip } from '@mui/material';
import {
  GridColDef,
  GridRenderCellParams,
  GridValueSetterParams,
} from '@mui/x-data-grid-premium';
import { nanoid } from 'nanoid';
import ImageDefault from '../../../assets/utentebase.png';
import DoneIcon from '@mui/icons-material/Done';

const columnsFun = (isBluBookingActive: boolean) => {
  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', hide: true },
    {
      field: 'photo',
      headerName: '',
      width: 75,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'left',
      align: 'center',
      renderCell: (params: GridRenderCellParams) => {
        console.log('params', params.value);
        return (
          <Avatar
            key={nanoid()}
            sx={{
              bgcolor: params?.value
                ? 'trasparent'
                : `#${Math.floor(Math.random() * 16777215).toString(16)}`,
              border: `thin solid var(--divider-color)`,
            }}
            alt="Immagine utente"
            src={
              params?.value && params.value !== '' ? params.value : ImageDefault
            }
          />
        );
      },
    },
    {
      field: 'isIMOActive',
      headerName: 'App Attiva',
      width: 150,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: GridRenderCellParams) => {
        if (params.value === null || params.value === false)
          return <Chip label="App non attiva" disabled />;
        return <Chip label="App attiva" icon={<DoneIcon />} color="success" />;
      },
    },
    {
      field: 'isActive',
      headerName: 'Attivo',
      width: 75,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: GridRenderCellParams) => {
        return <Checkbox checked={!!params.value} disabled />;
      },
    },
    {
      field: 'username',
      headerName: 'Utente',
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'left',
      align: 'left',
      valueSetter: (params: GridValueSetterParams) => {
        return {
          ...params.row,
          name: params.value + params.row['surname'],
        };
      },
    },
    {
      field: 'sign',
      headerName: 'Codice',
      width: 70,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'name',
      headerName: 'Nome',
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'left',
      align: 'left',
      hide: true,
    },
    {
      field: 'surname',
      headerName: 'Cognome',
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'left',
      align: 'left',
      hide: true,
    },
    {
      field: 'profile',
      headerName: 'Profilo',
      width: 200,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'internalCode',
      headerName: 'Filiale',
      width: 75,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'profilo',
      headerName: 'Profilo',
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'left',
      align: 'center',
      hide: true,
    },
    {
      field: 'isOptician',
      headerName: 'Ottico',
      width: 75,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      hide: false,
      renderCell: (params: GridRenderCellParams) => {
        return <Checkbox checked={!!params.value} disabled />;
      },
    },
    {
      field: 'hasAgenda',
      headerName: 'Agenda',
      width: 75,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: GridRenderCellParams) => {
        return <Checkbox checked={!!params.value} disabled />;
      },
    },
    {
      field: 'color',
      headerName: 'Colore',
      width: 70,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: GridRenderCellParams) => {
        return !!params.value ? (
          <Badge
            key={params.value + 'color'}
            sx={{
              borderRadius: '50%',
              backgroundColor: `${params.value}95`,
              width: 30,
              height: 30,
              border: `thin solid ${params.value}`,
            }}
            overlap="circular"
          />
        ) : (
          <Badge
            key={nanoid()}
            sx={{
              borderRadius: '50%',
              backgroundColor: 'white',
              width: 30,
              height: 30,
              border: `thin solid var(--divider-color)`,
            }}
            overlap="circular"
          />
        );
      },
    },
    {
      field: 'filiale2',
      headerName: 'Filiale',
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'left',
      align: 'center',
      hide: true,
    },
    {
      field: 'stato',
      headerName: 'Stato',
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'left',
      align: 'center',
      hide: true,
    },
  ];
  return columns;
};

export default columnsFun;
